import styled from "styled-components";

export const Logo = styled.img`
  margin: 50px 0;
  width: 50%;
  filter: drop-shadow(4px 4px 6px #493882)
`;

